import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import css from './Logo.css'
import { LogoIcon } from './LogoIcon'

export const Logo: FC = () => {
  return (
    <Link className={css.logo} to="/">
      <LogoIcon />
      <span className={css.text}>
        <Text as="span" size="l" weight="bold" view="primary">
          Геомейт
        </Text>
        <Text as="span" size="l" view="ghost" weight="bold">
          WEB
        </Text>
      </span>
    </Link>
  )
}
